import { useQuery } from '@tanstack/react-query';
import api from '../api/axiosInstance';
import { AxiosError } from 'axios';

export interface PurposeBuiltNodeDetails {
  id: string;
  name: string;
  basebandType: string;
  status: string;
  logUrl: string;
}

async function getNodeDetails(workflowUuid: string): Promise<PurposeBuiltNodeDetails[]> {
  try {
    const { data } = await api.get(`/api/pb-nodes/workflow/${workflowUuid}`);
    return data ?? [];
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 404) {
      return [];
    }
    throw error;
  }
}

export function useNodeDetails(workflowUuid: string) {
  return useQuery<PurposeBuiltNodeDetails[]>({
    queryKey: ['pb-node-details', workflowUuid],
    queryFn: () => getNodeDetails(workflowUuid),
    enabled: Boolean(workflowUuid),
    retry: false,
    refetchOnWindowFocus: false,
  });
}
